import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { VISA_TYPE_ID } from "libs/configs/constant";
import LoadingAdapter from "libs/utils/LoadingAdapter";
import CancelVisaService from "services/CancelVisaService";

let initialState = {
    step: '',
    showReqeustDoc: false,
    docRequests: [],
    smartDetail: null,
    partForm: [],
    currentDraftId: null,
    currentDraftDetail: null,
    oldData: null
};

export const getCancelRequestDoc = createAsyncThunk(
    "cancelVisa/getCancelRequestDoc",
    async (body) => {

        if (body.currSmartServiceId === VISA_TYPE_ID.SMART_T) {
            body.conditionType = 'T';
        }
        if (body.currSmartServiceId === VISA_TYPE_ID.SMART_I) {
            body.conditionType = 'I';
        }
        if (body.currSmartServiceId === VISA_TYPE_ID.SMART_S) {
            body.conditionType = 'S';
        }
        if (body.currSmartServiceId === VISA_TYPE_ID.SMART_E) {
            body.conditionType = 'E';
        }
        if (body.currSmartServiceId === VISA_TYPE_ID.SMART_O) {
            body.conditionType = 'O';
        }
        const response = await CancelVisaService.getCancelRequestDoc(body);
        return response?.results;
    }
);


export const addSmartFromCancel = createAsyncThunk(
    "cancelVisa/addSmartFromCancel",
    async (body) => {
        const response = await CancelVisaService.addSmartFromCancel(body);
        return response?.results?.draftId;
    }
);


export const getSmartFormList = createAsyncThunk(
    "cancelVisa/getSmartFormList",
    async (body) => {
        const response = await CancelVisaService.getSmartFormList(body);
        return response?.results;
    }
);


export const getOldDataSmartFormList = createAsyncThunk(
    "cancelVisa/getOldDataSmartFormList",
    async (body) => {
        const response = await CancelVisaService.getSmartFormList(body);
        return response?.results;
    }
);


export const getPartFormList = createAsyncThunk(
    "cancelVisa/getPartFormList",
    async (body) => {
        const response = await CancelVisaService.getPartFormList(body);
        return response?.results;
    }
);



export const getPartFormDetail = createAsyncThunk(
    "cancelVisa/getPartFormDetail",
    async (body) => {
        const response = await CancelVisaService.getSmartFormList(body);
        return response?.results;
    }
);


export const addSmartCancel = createAsyncThunk(
    "cancelVisa/addSmartCancel",
    async (draftId) => {
        const response = await CancelVisaService.addSmartCancel(draftId);
        return response?.results;
    }
);



const cancelVisaSlice = createSlice({
    name: "cancelVisa",
    initialState: initialState,
    reducers: {
        setStep: (state, action) => {
            state.step = action.payload
        },
        readRequestDoc: (state, action) => {
            state.showReqeustDoc = action.payload
        },
    },
    extraReducers: (builder) => {
        LoadingAdapter.applyAsyncBuilder(getCancelRequestDoc, builder, ["docRequests"]);
        LoadingAdapter.applyAsyncBuilder(getSmartFormList, builder, ["smartDetail"]);
        LoadingAdapter.applyAsyncBuilder(getPartFormList, builder, ["partForm"]);
        LoadingAdapter.applyAsyncBuilder(addSmartFromCancel, builder, ["currentDraftId"]);
        LoadingAdapter.applyAsyncBuilder(getPartFormDetail, builder, ["currentDraftDetail"]);
        LoadingAdapter.applyAsyncBuilder(addSmartCancel, builder);
        LoadingAdapter.applyAsyncBuilder(getOldDataSmartFormList, builder, ["oldData"]);
    },
});

export const { setStep, readRequestDoc } = cancelVisaSlice.actions

export default cancelVisaSlice.reducer;



export const selectRequestDocs = (state) => {

    const { docRequests } = state.cancelVisa;
    let group = docRequests.reduce((r, a) => {
        r[a.typeDocumentName] = [...r[a.typeDocumentName] || [], a];
        return r;
    }, {});

    return group;
};